<button class="tab {{ active ? 'tab--active' : '' }} " (click)="tabClicked.next(true)">
  <ng-content></ng-content>
</button>
